import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiMapPin, FiArrowUpRight} = FiIcons;
const mapUrl = 'https://www.google.com/maps/search/?api=1&query=Avinguda%20Pau%20Vila%2C%201%2C%2008181%20Pedra-Santa%2C%20Sentmenat%2C%20Barcelona';

export default function Location({copy}) {
  return (
    <section id="location" className="location section-shell">
      <div className="location-image" />
      <div className="location-content">
        <p className="eyebrow">{copy.eyebrow}</p>
        <h2>{copy.title}</h2>
        <div className="location-line">
          <SafeIcon icon={FiMapPin} />
          <strong>{copy.name}</strong>
        </div>
        <p>{copy.copy}</p>
        <a
          className="text-link"
          href={mapUrl}
          target="_blank"
          rel="noreferrer"
        >
          {copy.button}
          <SafeIcon icon={FiArrowUpRight} />
        </a>
        <a
          className="text-link"
          href="https://canmontcad.es"
          target="_blank"
          rel="noreferrer"
        >
          {copy.website}
          <SafeIcon icon={FiArrowUpRight} />
        </a>
      </div>
    </section>
  );
}